import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import generateLink from '../helpers/generate-link';

const UpcomingShipmentsNotice = ({ isCorpView, customerNumber }: { isCorpView: boolean, customerNumber: string }) => {
  const navigate = useNavigate();
  const shipmentsPath = 'shipments/upcoming';
  const shipmentsLink = generateLink(isCorpView, customerNumber, shipmentsPath)

  return (
    <li className="list-group-item">
      <FontAwesomeIcon color='#23b7e5' style={{ marginRight: '10px' }} icon={faTruck} />Upcoming Shipments -<Link component="button" onClick={() => navigate(shipmentsLink)} className="text-info"> View Details</Link>
    </li>
  )
}

export default UpcomingShipmentsNotice;